(function CalendarFilter($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('CalendarSearchIndex/filter', function onload() {
			$('.calendar-check-uncheck').click(function calendarFilterCheckUncheckAll() {
				if ($(this).is(":checked") === true) {
					$('.calendar-checkboxes').each(function calendarFilterCheckAction() {
						$(this).prop('checked', true);
					});
				} else {
					$('.calendar-checkboxes').each(function calendarFilterCheckAction() {
						$(this).prop('checked', false);
					});
				}
			});
		});
	});

}(jQuery, window.Adzuki || {}));